// Validation constants and regular expressions

/**
 * Regular expression that validates email addresses contain a period in the domain portion.
 * Ensures emails have a top-level domain by checking for a period after the @ symbol. This is
 * necessary because yup's built-in email validation allows emails without a period in the
 * domain portion. Emails like that can be technically valid, but are very rare and more likely
 * to be entered by mistake. Allows empty strings for optional fields.
 * @example
 * // Valid: user@domain.com, test@sub.domain.org, "" (empty string)
 * // Invalid: user@domain, test@localhost
 */
export const EMAIL_WITH_TLD_REGEX = /^$|^[^@\s]+@[^@\s.]+\.[^@\s]+$/;

/**
 * Regular expression for validating US phone numbers.
 * Does not allow numbers starting with 0 or 1 in the first digit.
 * @example
 * // Valid: (555) 123-4567
 * // Invalid: (055) 123-4567, 155-123-4567
 */
export const US_PHONE_REGEX = /^(\(?(?![01])\d{3}\)?)[-.\s]?\d{3}[-.\s]?\d{4}$/;

/**
 * Regular expression for validating non-US phone numbers.
 * Allows only digits
 */
export const NON_US_PHONE_REGEX = /^\d{1,13}$/;

/**
 * Regular expression for validating names (first, middle, last names).
 * Allows letters, apostrophes, spaces, and hyphens only.
 * @example
 * // Valid: John, Mary-Jane, O'Connor, Van Der Berg
 * // Invalid: John123, Mary@Jane, O'Connor!
 */
export const NAME_REGEX = /^[A-Za-z'\s-]+$/;